import { useEffect, useState } from "react";
import { toast } from "sonner";
import { admin } from "../../lib/api";
import { panel, inputCls, btnPrimary, Field, PageHead } from "../ui";
import { Trash2 } from "lucide-react";

const blank = { code: "", type: "percentage", value: 10, min_order: 0, max_discount: "", active: true };

export default function Coupons() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(blank);
  const load = () => admin.get("/admin/coupons").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const add = async () => {
    if (!form.code) return;
    await admin.post("/admin/coupons", { ...form, value: Number(form.value), min_order: Number(form.min_order), max_discount: form.max_discount ? Number(form.max_discount) : null });
    setForm(blank); toast.success("Created"); load();
  };
  const del = async (c) => { await admin.delete(`/admin/coupons/${c.id}`); load(); };

  return (
    <div>
      <PageHead title="Coupons" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className={`${panel} p-5 space-y-3 h-fit`}>
          <Field label="Code"><input className={inputCls + " uppercase"} value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} data-testid="coupon-code" /></Field>
          <Field label="Type">
            <select className={inputCls} value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
              <option value="percentage">Percentage</option><option value="fixed">Fixed Amount</option><option value="free_shipping">Free Shipping</option>
            </select>
          </Field>
          {form.type !== "free_shipping" && <Field label="Value"><input type="number" className={inputCls} value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} /></Field>}
          <Field label="Min order (₹)"><input type="number" className={inputCls} value={form.min_order} onChange={(e) => setForm({ ...form, min_order: e.target.value })} /></Field>
          {form.type === "percentage" && <Field label="Max discount (₹)"><input type="number" className={inputCls} value={form.max_discount} onChange={(e) => setForm({ ...form, max_discount: e.target.value })} /></Field>}
          <button onClick={add} className={btnPrimary} data-testid="coupon-add-btn">Create Coupon</button>
        </div>
        <div className={`${panel} p-5 lg:col-span-2`}>
          {list.map((c) => (
            <div key={c.id} className="flex items-center justify-between py-3 border-b border-zinc-900">
              <div>
                <span className="text-sm font-bold text-white tracking-wider">{c.code}</span>
                <span className="text-xs text-zinc-500 ml-3">{c.type === "percentage" ? `${c.value}% off` : c.type === "fixed" ? `₹${c.value} off` : "Free shipping"} · min ₹{c.min_order}</span>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-xs text-zinc-600">{c.used_count || 0} used</span>
                <button onClick={() => del(c)} className="text-zinc-500 hover:text-red-400"><Trash2 size={15} /></button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
